export function downloadZipFile(base64, filename = "matched_results.zip") {
	const byteCharacters = atob(base64);
	const byteArrays = [];

	for (let offset = 0; offset < byteCharacters.length; offset += 512) {
		const slice = byteCharacters.slice(offset, offset + 512);
		const byteNumbers = Array.from(slice, (char) => char.charCodeAt(0));
		byteArrays.push(new Uint8Array(byteNumbers));
	}

	const blob = new Blob(byteArrays, { type: "application/zip" });
	const url = URL.createObjectURL(blob);
	const a = document.createElement("a");
	a.href = url;
	a.download = filename;
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
	URL.revokeObjectURL(url);
}
